var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"page-list"},[_c('li',{staticClass:"active"},[_c('a',{attrs:{"href":"#"}},[_vm._v("1")])]),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("2")])]),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("3")])]),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("4")])]),_c('li',[_c('a',{attrs:{"href":"#"}},[_c('i',{staticClass:"fas fa-angle-right"})])])])
}]

export { render, staticRenderFns }